/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Search_LabelInputs */

const en_events_search_label = /** @type {(inputs: Events_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find an event`)
};

const pl_events_search_label = /** @type {(inputs: Events_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź wydarzenie`)
};

/**
* | output |
* | --- |
* | "Find an event" |
*
* @param {Events_Search_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const events_search_label = /** @type {((inputs?: Events_Search_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Search_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_events_search_label(inputs)
	return en_events_search_label(inputs)
});